function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 6l5-3 5 3v12l-5 3-10-6V9l10 6V9l-5-3z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M12 18l-5 3-5-3V6l5-3 10 6v6L7 9v6l5 3z"
})));